// Copyright 2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import RpcErrorMessage from "./RpcErrorMessage";

export default RpcErrorMessage;
